import { Context, ContextManager, ROOT_CONTEXT } from '@opentelemetry/api';

export class ManualContextManager implements ContextManager {
  private enabled = false;
  private activeContext = ROOT_CONTEXT;

  active(): Context {
    return this.activeContext;
  }

  setActiveContext(context: Context) {
    this.activeContext = context;
  }

  clearActiveContext() {
    this.activeContext = ROOT_CONTEXT;
  }

  disable(): this {
    this.activeContext = ROOT_CONTEXT;
    this.enabled = false;
    return this;
  }

  enable(): this {
    if (this.enabled) {
      return this;
    }
    this.enabled = true;
    this.activeContext = ROOT_CONTEXT;
    return this;
  }

  bind<T>(_context: Context, _target: T): T {
    throw new Error('Not implemented because we do not need it');
  }

  with<A extends unknown[], F extends (...args: A) => ReturnType<F>>(
    context: Context | null,
    fn: F,
    thisArg?: ThisParameterType<F>,
    ...args: A
  ): ReturnType<F> {
    const previousContext = this.activeContext;
    this.activeContext = context || ROOT_CONTEXT;

    try {
      return fn.call(thisArg, ...args);
    } finally {
      this.activeContext = previousContext;
    }
  }
}
